import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {intlShape, FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/SepaPage/SepaPage';

export class Creditor extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        creditorId: PropTypes.string.isRequired,
        creditorName: PropTypes.string.isRequired,
        creditorStreet1: PropTypes.string.isRequired,
        creditorCity: PropTypes.string.isRequired,
        creditorPostalCode: PropTypes.string.isRequired,
        creditorCountryName: PropTypes.string.isRequired,
    };

    render() {
        const { creditorId, creditorName, creditorStreet1, creditorCity, creditorPostalCode, creditorCountryName } = this.props;
        return (
            <div className="creditor-name">
                <h4>
                    <FormattedMessage id={`${LOCALE_PREFIX}.creditor`} />
                </h4>
                <span>{creditorName}</span>
                <div className="creditor-address">
                    <div className="creditor-street">
                        <span>{creditorStreet1}</span>
                    </div>
                    <div className="creditor-country">
                        <span>{creditorPostalCode} {creditorCity} {creditorCountryName}</span>
                    </div>
                </div>

                <div className="marginTop">
                    <h4>
                        <FormattedMessage id={`${LOCALE_PREFIX}.creditorId`} />
                    </h4>
                    <span>{creditorId}</span>
                </div>
            </div>

        );
    }
}

export const mapStateToProps = state => ({
    creditorId: _.get(state, 'serverData.decisionModel.creditor.id'),
    creditorName: _.get(state, 'serverData.decisionModel.creditor.name'),
    creditorStreet1: _.get(state, 'serverData.decisionModel.creditor.street1'),
    creditorCity: _.get(state, 'serverData.decisionModel.creditor.city'),
    creditorPostalCode: _.get(state, 'serverData.decisionModel.creditor.postalCode'),
    creditorCountryName: _.get(state, 'serverData.decisionModel.creditor.countryName')
});

export default connect(mapStateToProps)(injectIntl(Creditor));
